import type { Routes } from '@angular/router';

import { UnauthorizedComponent } from './core/unauthorized/unauthorized.component';
import { AUTH_GUARD } from './guards/auth.guard';
import { PermissionResolver } from './guards/permission.resolver';
import { VIEW_GUARD } from './guards/view.guard';

export const ROUTES: Routes = [
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
  {
    path: 'auth',
    canActivate: [AUTH_GUARD],
    loadChildren: () => import('./templates/auth/auth.routes').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'main',
    canActivate: [VIEW_GUARD],
    resolve: { permissions: PermissionResolver },
    loadChildren: () => import('./templates/views/views.routes').then((m) => m.VIEWSROUTE),
  },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: '**', component: UnauthorizedComponent },
];
